import React from "react";
import { Box, Typography} from "@mui/material";
import { PictureWithTextProps } from "../../interfaces";

const PictureWithText: React.FC<PictureWithTextProps> = ({
  // Content with defaults
  backgroundImage,
  titleSegments = [
    { text: "Trust", color: "darkPurple.500" },
    { text: "&", color: "lightPurple.500" },
    { text: "Transparency", color: "darkPurple.500" }
  ],
  description = "WE UPHOLD OUR COMMITMENTS WITH HONESTY, RESPONSIBILITY, AND TRANSPARENCY—NO FALSE PROMISES, JUST RELIABLE SERVICE",
  
  // Styling with defaults
  backgroundColor = "lightgray",
  containerSx,
  titleSx,
  descriptionSx,
  minHeight = { xs: '400px', md: '600px' },
  paddingTop = { xs: '40px', md: '184px' },
  gap = '32px'
}) => {
  return (
    <Box
      sx={{
        maxWidth: "1320px",
        minHeight: minHeight,
        width: "100%",
        borderRadius: "12px",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: gap,
        px: 1.5,
        paddingTop: paddingTop,
        paddingX: { xs: '20px', md: '0' },
        background: `url(${backgroundImage}) ${backgroundColor} 50% / cover no-repeat;`,
        aspectRatio: "2/1",
        fontFamily: "Manrope",
        ...containerSx
      }}
    >
      <Typography
        variant="subtitle8"
        sx={{
          position: "relative",
          width: "fit-content",
          whiteSpace: { xs: 'break-spaces', md: 'nowrap' },
          textTransform: "uppercase",
          textAlign: "center",
          textWrap: "wrap",
          ...titleSx
        }}
      >
        {titleSegments.map((segment, index) => (
          <Box 
            component="span" 
            key={index} 
            sx={{ color: segment.color || "darkPurple.500" }}
          >
            {segment.text}
          </Box>
        ))}
      </Typography>

      <Typography
        variant="body7"
        sx={{
          position: "relative",
          width: "100%",
          color: "gray.400",
          textAlign: "center",
          textTransform: "uppercase",
          maxWidth: { xs: "335px", md: "540px" },
          ...descriptionSx
        }}
      >
        {description}
      </Typography>
    </Box>
  );
};

export default PictureWithText;